import styled, { css } from 'styled-components'

export const ButtonWrap = styled.div`
  max-width: 32px;
  height: 40px;
  display: flex;
  align-items: center;
  position: relative;

  & button {
    height: 32px;
    padding: 0 8px;
    border-radius: 4px;

    svg {
      top: 0;
      margin-right: 0;
    }
  }
`

export const Menu = styled.div`
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  padding: 8px 0;
  background: var(--t-surface-block);
  border: 1px solid var(--t-button-more-action-menu-border);
  box-shadow:
    0 8px 16px -2px rgba(27, 36, 44, 0.12),
    0 2px 2px -1px rgba(27, 35, 44, 0.04);
  z-index: 12000;

  min-width: 200px;
  max-width: 320px;
  max-height: 60vh;
  overflow: auto;

  opacity: 0;
  transform: translateY(-4px) scale(0.98);
  pointer-events: none;
  visibility: hidden;

  transition:
    opacity 120ms ease,
    transform 160ms cubic-bezier(0.2, 0.7, 0.2, 1),
    visibility 0s linear 160ms;

  &[data-open='true'] {
    opacity: 1;
    transform: translateY(0) scale(1);
    pointer-events: auto;
    visibility: visible;
    transition:
      opacity 120ms ease,
      transform 160ms cubic-bezier(0.2, 0.7, 0.2, 1),
      visibility 0s;
  }

  &[data-portal='true'] {
    position: fixed;

    ${(p) =>
      p.menuPosition === 'left' &&
      css`
        transform-origin: top left;
      `}
    ${(p) =>
      p.menuPosition === 'right' &&
      css`
        transform-origin: top right;
      `}
  }

  & > button {
    padding: 9.5px 12px;
    display: flex;
    align-items: center;
    gap: 12px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.2;
    background: transparent;
    border: 0;
    color: var(--t-button-more-action-menu-text);
    white-space: nowrap;

    &:hover {
      background: var(--t-button-more-action-menu-hover-bg);
    }
  }

  & svg {
    flex-shrink: 0;
    color: var(--t-button-more-action-menu-color);
  }

  & span {
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
    &[data-open='true'] {
      transition: none;
    }
  }
`
